import { render, staticRenderFns } from "./CategoryTypesLoader.vue?vue&type=template&id=ad1120b4"
import script from "./CategoryTypesLoader.vue?vue&type=script&lang=js"
export * from "./CategoryTypesLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports